import React, { useEffect, useState, useRef, useCallback } from 'react';
import { apiService } from '../services/api';

const NotificationPopup = ({ type, onClose, onBirthdayTreatGiveRound }) => {
  const [termsText, setTermsText] = useState('');
  const [loading, setLoading] = useState(type === 'terms');
  const [termsReachedEnd, setTermsReachedEnd] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (type === 'terms') {
      setTermsReachedEnd(false);
      apiService.getTerms()
        .then((data) => {
          if (data.success && data.terms) setTermsText(data.terms);
        })
        .catch(() => setTermsText('Satzung konnte nicht geladen werden.'))
        .finally(() => setLoading(false));
    }
  }, [type]);

  const checkScrollEnd = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    const { scrollTop, scrollHeight, clientHeight } = el;
    if (scrollHeight <= clientHeight + 8) {
      setTermsReachedEnd(true);
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight - 12) {
      setTermsReachedEnd(true);
    }
  }, []);

  useEffect(() => {
    if (type !== 'terms' || loading || !termsText) return;
    const t = setTimeout(() => {
      checkScrollEnd();
    }, 100);
    return () => clearTimeout(t);
  }, [type, loading, termsText, checkScrollEnd]);

  const handleLater = async () => {
    try {
      if (type === 'birthday') await apiService.birthdayRemindLater();
      if (type === 'birthday_treat') await apiService.birthdayTreatRemindLater();
      if (type === 'entry') await apiService.entryRemindLater();
    } catch (e) {
      console.error(e);
    }
    onClose();
  };

  const handleBirthdayOk = async () => {
    try {
      await apiService.birthdayAcknowledge();
    } catch (e) {
      console.error(e);
    }
    onClose();
  };

  const handleBirthdayTreatGive = () => {
    if (onBirthdayTreatGiveRound) onBirthdayTreatGiveRound();
    onClose();
  };

  const handleAcceptTerms = async () => {
    if (!termsReachedEnd) return;
    try {
      await apiService.acceptTerms();
    } catch (e) {
      console.error(e);
    }
    onClose();
  };

  const titles = {
    birthday: '🎂 Geburtstag',
    birthday_treat: '🍻 Stammtisch ausgeben',
    entry: '🍻 Einstand',
    terms: '📜 Satzung',
  };
  const body = {
    birthday: 'Alles Gute zum Geburtstag!',
    birthday_treat:
      'Du hattest Geburtstag! Beim Stammtisch ist es üblich, einmal einen ganzen Abend für alle auszugeben. ' +
      'Das kannst du jetzt erledigen – oder dich später erinnern lassen (dann blenden wir die Meldung für 24 Stunden aus).',
    entry: 'Willkommen beim Stammtisch! Bist du neu? Dann steht dir ein Einstand zu – oder du erinnerst uns später.',
    terms: null,
  };

  const backdropClose = type !== 'birthday_treat' && type !== 'terms';

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/55 backdrop-blur-sm"
      onClick={backdropClose ? onClose : undefined}
      role="presentation"
    >
      <div
        className="bg-accent-3 rounded-lg shadow-lg border-2 border-accent-2 max-w-md w-full p-6 text-bg-1"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="notification-popup-title"
      >
        <h3 id="notification-popup-title" className="text-xl font-heading font-bold mb-3">
          {titles[type]}
        </h3>
        {type === 'terms' ? (
          loading ? (
            <p className="text-text-subtle">Lade Satzung…</p>
          ) : (
            <>
              <div
                ref={scrollRef}
                onScroll={checkScrollEnd}
                className="max-h-60 overflow-y-auto text-sm mb-2 whitespace-pre-wrap rounded-lg border border-accent-1/20 p-3 bg-bg-1/30"
              >
                {termsText}
              </div>
              {!termsReachedEnd && (
                <p className="text-xs text-bg-1/80 mb-3">
                  Bitte bis zum Ende scrollen, um zu akzeptieren.
                </p>
              )}
            </>
          )
        ) : (
          <p className="text-sm mb-4">{body[type]}</p>
        )}
        <div className="flex gap-2 justify-end flex-wrap">
          {type === 'birthday_treat' && (
            <>
              <button
                type="button"
                onClick={handleLater}
                className="px-4 py-2 rounded-lg bg-bg-2 text-text-strong border border-accent-1/30 hover:bg-bg-3"
              >
                Später erinnern
              </button>
              <button
                type="button"
                onClick={handleBirthdayTreatGive}
                className="px-4 py-2 rounded-lg bg-accent-1 text-white hover:bg-accent-2 font-medium"
              >
                Ganzen Abend ausgeben
              </button>
            </>
          )}
          {(type === 'birthday' || type === 'entry') && (
            <button
              type="button"
              onClick={handleLater}
              className="px-4 py-2 rounded-lg bg-bg-2 text-text-strong border border-accent-1/30 hover:bg-bg-3"
            >
              Später erinnern
            </button>
          )}
          {type === 'terms' && !loading && (
            <button
              type="button"
              onClick={handleAcceptTerms}
              disabled={!termsReachedEnd}
              className={`px-4 py-2 rounded-lg font-medium transition-opacity ${
                termsReachedEnd
                  ? 'bg-accent-1 text-white hover:bg-accent-2'
                  : 'bg-accent-1/40 text-white/70 cursor-not-allowed'
              }`}
            >
              Akzeptieren
            </button>
          )}
          {type === 'birthday' && (
            <button
              type="button"
              onClick={handleBirthdayOk}
              className="px-4 py-2 rounded-lg bg-accent-1 text-white hover:bg-accent-2"
            >
              OK
            </button>
          )}
          {type === 'entry' && (
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg bg-accent-1 text-white hover:bg-accent-2"
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;
